import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { RootState } from "../../app/store";
import { PlayerMode, selectPlayer } from "../../features/player/playerSlice";
import CSS from "csstype";
import {
  openSidebar,
  selectTheme,
  showLoading,
  showLoginPopup,
  ThemeMode,
} from "../../features/theme/themeSlice";
import lang from "../../fakedata/language.json";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Modal} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as faSolidStar } from "@fortawesome/free-solid-svg-icons";

type GameProps = {
  title: string;
  image: string;
  provider: string;
  addclass?: string;
  providerNoFormat?: boolean;
  operator: string; // nome operatore di gioco
  urlEndPoint: string;
  showLabel?: string;
  gameId: string;
  imageprovider?:string;
  onClick?: () => void;
  onGameUnavailabe?: () => void;
  bookmark?: boolean;
  onBookmarkClick?: (gameId: string) => void;
  nascosti?: boolean;
  category?: string | null;
};

const GameComponent: React.FC<GameProps> = ({
  title,
  image,
  provider,
  addclass,
  providerNoFormat,
  operator,
  urlEndPoint,
  gameId,
  showLabel,
  onClick,
  onGameUnavailabe,
  bookmark,
  imageprovider,
  onBookmarkClick,
  nascosti = false,
  category = null,
}) => {
  const navigate = useNavigate();
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const theme = useAppSelector(selectTheme);
  const intl = useIntl();
  const player = useAppSelector(selectPlayer);
  const [bookmarkLocal, setBookmarkLocal] = useState(bookmark);
  const languages = lang.filter((l) => l.langId == theme.language);
  const dispatch = useDispatch();
  const [playButtonVisible, setPlayButtonVisible] = useState(false);

  const style: CSS.Properties = {};
  useEffect(() => {
    setBookmarkLocal(bookmark);
  }, [bookmark]);

  return (
    <div
      style={style}
      className={`d-game pointer ${addclass?addclass:''}`}
      onClick={() => {
        if (onClick) onClick();

        if (urlEndPoint === "") {
          onGameUnavailabe && onGameUnavailabe();
          return;
        }
        dispatch(showLoading(true));
        navigate(`${urlEndPoint}`, {
          state: { gameId: `${gameId}` },
        });
        dispatch(openSidebar(true))
      }}
    >
      {showLabel && showLabel !== "false" && (
        <div className="d-game-title">
         
          <span>{ title  }</span>
        </div>
      )
      
      
      }

      <div
        className="d-game-not-logged overlay-virtuali-not-logged d-flex"
        onMouseOver={() => {
          if (!playButtonVisible) setPlayButtonVisible(true);
        }}
        onMouseLeave={() => setPlayButtonVisible(false)}
        onClick={(e) => {
         
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {playButtonVisible && (
          <>
            {player.logged && player.mode !== PlayerMode.KIOSK && (
              <div
                className="favorite-game pointer"
                onClick={() => {
                  setBookmarkLocal(!bookmarkLocal);
                 
                  if (onBookmarkClick) onBookmarkClick(gameId);
                }}
              >
                <FontAwesomeIcon
                  icon={bookmarkLocal ? faSolidStar : faStar}
                  color="yellow"
                />
              </div>
            )}
            <div
              className={`d-game-provider ${
                providerNoFormat ? "d-game-provider-no-format" : ""
              }`}
            >
           { imageprovider?    <img style={{width:200, height:30 ,marginTop:18}} src={imageprovider}></img> :provider}
            </div>
            <Button
            
              className="with-border playbott"
              onClick={(e) => {
             //   alert('close modal');

                //@ts-ignore
//console.log(document.getElementsByClassName('ant-modal-centered')[0]);
  
                e.preventDefault();
                e.stopPropagation();
                if (urlEndPoint !== "") {
                  if (!player.logged) dispatch(showLoginPopup(true));
                  else {
                    dispatch(showLoading(true));
                    if (!nascosti)
                      navigate(`${urlEndPoint}`, {
                        state: { gameId: `${gameId}` },
                      });
                    else
                      navigate(`/playnascosti`, {
                        state: { gameId: `${gameId}` },
                      });
                  }
                } else {
                  if (onGameUnavailabe) onGameUnavailabe();
                }
              }}
            >
              <FormattedMessage id="Play" />
            </Button>
            <p>{title}</p>
          </>
        )}
      </div>
      <img
        alt={`image-${image}`}
        src={image}
        className="game-image"
        width={376}
        height={250}
      />
    </div>
  );
};

export default GameComponent;
